import { format } from "rut.js";
import { columns } from "../../../dtos/columns";
import { RowComprobanteLiquidacion } from "../models/headerComprobanteLiquidacion";
import { numericFormatter } from "react-number-format";
import AccionesLiquidacion from "../components/accionesLiquidacion";

interface IProps {
    control: any;
    rowIndex?: number;
    setRowSelected?: any;
    setShowFormulario?: any;
    isLiquidacion: boolean;
    setIsCreating?: any;
    setShowEliminacion?: any;
}

export function useColumns({control, setRowSelected, setShowFormulario, isLiquidacion, setIsCreating, setShowEliminacion} : IProps) {

    const COLUMNS: columns<RowComprobanteLiquidacion>[] = [
        {
            name: "Acciones",
            selector: (row: RowComprobanteLiquidacion) => '',
            cell: (row: RowComprobanteLiquidacion) => {
                return !isLiquidacion ? 
                        <AccionesLiquidacion 
                            row={row}
                            setRowSelected={setRowSelected}
                            setShowFormulario={setShowFormulario}
                            setIsCreating={setIsCreating}
                            setShowEliminacion={setShowEliminacion}/>
                    : "";
            },
            allowOverflow: true,
            button: true,
            export: false,
        },
        {
            name: 'Tipo beneficiario',
            selector: (row: RowComprobanteLiquidacion) => row.tipoBeneficiario,
            sortable: true,
            sortField: 'tipoBeneficiario',
            wrap: true,
            alling: 'left',
            export: true,
        },
        {
            name: 'RUT',
            selector: (row: RowComprobanteLiquidacion) => format(row.rut!),
            sortable: true,
            sortField: 'rut',
            wrap: true,
            alling: 'left',
            export: true,
        },
        {
            name: 'Nombre',
            selector: (row: RowComprobanteLiquidacion) => row.nombre + 
                                                        (row.apellidoPaterno ?  (" " + row.apellidoPaterno) : "") + 
                                                        (row.apellidoMaterno ? (" " + row.apellidoMaterno) : ""), 
            sortable: true,
            sortField: 'nombre',
            wrap: true,
            alling: 'left',
            export: true,
        },
        {
            name: 'Monto',
            selector: (row: RowComprobanteLiquidacion) => numericFormatter((Math.round(row.monto * 100)/100).toString(), { "thousandsGroupStyle": "thousand", "thousandSeparator": ".", "decimalSeparator": ",", "prefix": "CLP " }),
            sortable: true,
            sortField: 'nombre',
            wrap: true,
            export: true,
            alling: 'left',
        },
    ]

    return { COLUMNS };
}